import Menu from '../data/menu'

export const state = () => ({
  data: Menu.data
})

// actions
export const actions = {
  async fetchShopCategories ({ dispatch, state }) {
    const result = await dispatch('categories/fetchCategories', null, { root: true })
    if (!result || result.length === 0) {
      return
    }
    state.data.forEach((item) => {
      if (Object.prototype.hasOwnProperty.call(item, 'shop') && item.shop) {
        item.children = [
          // { 'path': item.path, 'title': this.$i18n.t('all'), 'type': 'link' }
        ]
        result.forEach((category) => {
          category.path = item.path + '/' + category.slug
        })
        item.children.push(...result)
      }
    })
  },
  async fetchBlogCategories ({ dispatch, state }) {
    const categories = await dispatch('blog/fetchCategories', null, { root: true })
    if (!categories || categories.length === 0) {
      return
    }
    state.data.forEach((item) => {
      // if(item.hasOwnProperty('blog') && item.blog) {
      //   item.children = [
      //     { 'path': item.path, 'title': this.$i18n.t('all'), 'type': 'link' }
      //   ]
      //   let blog_categories = categories.filter(
      //     (category) => category.about_us === false
      //   );
      //   blog_categories.forEach((category) => {
      //     category.path = item.path + '/' + category.slug
      //   })
      //   item.children.push(...blog_categories)
      // } else
      if (Object.prototype.hasOwnProperty.call(item, 'about_us') && item.about_us) {
        const about_us_categories = categories.filter(
          category => category.about_us === true
        )
        about_us_categories.forEach((category) => {
          category.path = item.path + '/' + category.slug
        })
        item.children = about_us_categories
      }
    })
  }
}
